<template>
  <div id="app">
    <div id="header"></div>
    <keep-alive ref="keepAlive">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import {NioOsSDK} from '@mp/os-sdk';
import util from '@/util/util';
import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import nbNO from 'vant/es/locale/lang/nb-NO';
import moment from 'moment';
import 'vant/lib/index.css';

export default {
  name: 'App',
  created() {
    // //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store') ) {
      this.$store.replaceState({ ...this.$store.state, ...JSON.parse(sessionStorage.getItem('store'))});
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', ()=>{
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });

    // 首页刷新 清除store
    if (this.$route.name === 'Index') {
      sessionStorage.removeItem('store');
    }
  },
  async mounted() {
    console.log('env is: ', util.getEnvInfo().env)
    const sdk = new NioOsSDK(util.getEnvInfo().env, {
      apiPrefix: process.env.VUE_APP_ENV === 'local' ? 'http://www-local.eu.nio.com:8680' : undefined
    });
    await sdk.setLocale({ ...this.$location })
    sdk.renderHeader(document.getElementById('header'));
    let endTime = new Date().getTime();
    console.log(`mounted：${endTime - window._supremeStartTime}`);
    console.log('check sessionId', sdk.options.sessionId)
  },
  methods: {}
};
</script>

<style lang="scss">
@import "../../assets/scss/base";
@import "../../assets/scss/rewrite";

@font-face {
  font-family: 'BlueSkyStandard-Regular';
  src: url('../../assets/fonts/BlueSkyStandardRegular.ttf') format("truetype");
  src: url('../../assets/fonts/BlueSkyStandardRegular.otf');
}
@font-face {
  font-family: 'BlueSkyStandard-Bold';
  src: url('../../assets/fonts/BlueSkyStandardBold.ttf') format("truetype");
  src: url('../../assets/fonts/BlueSkyStandardBold.otf');
}

#app {
  height: 100%;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // padding-top: $header-height;
  font-family: 'BlueSkyStandard-Regular';
}

#header>*{
  z-index: 101;
}
</style>
